import { mediaSchema, type Media } from '@plane/shared';
import { z } from 'zod';

import type { ImagemPreparada } from '@/modules/projects/preparar-imagem';
import { apiBaseUrl, apiRequest } from '@/services/http-client';

/**
 * Envia uma imagem avulsa e devolve o registro dela.
 *
 * Não passa por `apiRequest` na montagem do corpo porque o que sobe é o blob
 * cru, com o tipo no cabeçalho — mesmo desenho da foto de projeto. Mas passa
 * pelo cliente autenticado, que é o que garante a renovação de sessão no 401.
 */
export function uploadMedia(imagem: ImagemPreparada): Promise<Media> {
  const busca = new URLSearchParams({
    width: String(imagem.width),
    height: String(imagem.height),
  });

  return apiRequest(`/api/v1/media?${busca.toString()}`, mediaSchema, {
    method: 'POST',
    headers: { 'content-type': imagem.blob.type },
    body: imagem.blob,
  });
}

export function deleteMedia(id: string): Promise<void> {
  return apiRequest(`/api/v1/media/${id}`, z.void(), { method: 'DELETE' });
}

/** Endereço público dos bytes, para mostrar a imagem no painel. */
export function urlDaMedia(id: string): string {
  return `${apiBaseUrl}/api/v1/media/${id}`;
}
